import { render, staticRenderFns } from "./PreviousAddEdit.vue?vue&type=template&id=304c6b34"
import script from "./PreviousAddEdit.vue?vue&type=script&lang=js"
export * from "./PreviousAddEdit.vue?vue&type=script&lang=js"
import style0 from "./PreviousAddEdit.vue?vue&type=style&index=0&id=304c6b34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports